import type { ClientMiddleware } from './api';

declare var xsrftoken: string;

export function xsrft(http: { fetch(url: RequestInfo, init?: RequestInit) }): { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> } {
  return {
    fetch: function (url: RequestInfo, init?: RequestInit): Promise<Response> {
      init = init || <RequestInit>{};
      init.headers ??= {};
      init.headers['RequestVerificationToken'] = xsrftoken;
      return http.fetch(url, init);
    },
  };
}

export function token(): string {
  return xsrftoken;
}

export function xsrfheader(): string {
  return 'RequestVerificationToken: ' + xsrftoken;
}

export function xsrftMiddleware(): ClientMiddleware {
  return {
    onRequest(url: RequestInfo, init: RequestInit): void {
      init.headers = init.headers || {};
      init.headers['RequestVerificationToken'] = xsrftoken;
    },
  };
}